import { buildInspectorMessage } from '../services/ai.js';

export function handleInspectorMessage(userWallet) {
  if (!userWallet) {
    window.logToConsole("🔍 Connect your wallet first to use the Inspector.");
    return;
  }
  
  window.logToConsole('⏳ Inspector is analyzing wallet movements, please wait...');
  const targetWallet = prompt("Enter the wallet address to inspect:");
  
  if (targetWallet) {
    buildInspectorMessage(targetWallet).then(msg => {
      window.logToConsole(`🔍 INSPECTOR REPORT:\n${msg}`);
    }).catch(error => {
      console.error("Inspector error:", error);
      window.logToConsole("🔍 ERROR: Could not analyze wallet movements.");
    });
  }
}